var _pattern, _rect, _text, _text2, _text3, _text4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgYolo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 100,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, _pattern || (_pattern = /*#__PURE__*/React.createElement("pattern", {
    id: "fractal-pattern",
    x: 0,
    y: 0,
    width: 100,
    height: 100,
    patternUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100,
    fill: "url(#gradient)"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "gradient",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "pink",
      stopOpacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "50%",
    style: {
      stopColor: "pink",
      stopOpacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "pink",
      stopOpacity: 0.2
    }
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: "100%",
    height: "100%",
    fill: "url(#fractal-pattern)"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 20,
    y: 50,
    fontFamily: "Arial",
    fontSize: 48,
    fill: "#fff"
  }, "Y")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 70,
    y: 50,
    fontFamily: "Arial",
    fontSize: 48,
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "font-size",
    attributeType: "XML",
    dur: "50s",
    values: "24;28;24",
    repeatCount: "indefinite"
  }), "\n  O")), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    x: 120,
    y: 50,
    fontFamily: "Arial",
    fontSize: 48,
    fill: "#fff"
  }, "L")), _text4 || (_text4 = /*#__PURE__*/React.createElement("text", {
    x: 150,
    y: 50,
    fontFamily: "Arial",
    fontSize: 48,
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "font-size",
    attributeType: "XML",
    dur: "50s",
    values: "24;28;24",
    repeatCount: "indefinite"
  }), "\n  o\n  ")));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgYolo);
export default __webpack_public_path__ + "static/media/yolo.798bd0fa1c2a04f6112f7b3ca0796c20.svg";
export { ForwardRef as ReactComponent };